export const validate = (values, props) => {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!values.name || values.name.length < 1) {
        errors.name = 'Required';
    }
    if (!values.subject || values.subject.length < 1) {
        errors.subject = 'Required';
    }
    if (props.currentTemplate === null) {
        if (!values.type) {
            errors.type = 'Required';
        }
    }
    if (!values.content || values.content.length < 1) {
        errors.content = 'Required';
    }
    return errors;
};
